import React from 'react';

import { Field, FieldProps } from 'formik';

import Switch, { SwitchProps } from 'antd/es/switch';

import { FormikFieldProps } from '@common/react/components/Forms/FormikField/FormikField';

interface Props extends Omit<FormikFieldProps, 'render' | 'title'>, SwitchProps {

}

export const FormikFieldSwitch: React.FC<Props> = (props) => {
	const {
		fieldName,
		...rest
	} = props;

	const defaultProps: Partial<SwitchProps> = {
		size: 'small',
	};

	return <Field name={fieldName}>
		{({ form }: FieldProps<boolean>) => <Switch
			{...defaultProps}
			{...rest}
			checked={form.values[fieldName]}
			onChange={(checked) => form.setValues(
				(values) => ({ ...values, [fieldName]: checked }),
			)}
		/>}
	</Field>;
};
